require('./jv.search.filter.directive.webpack');

angular.module('jv.search.filters.directive', [
    'jv.search.filter.directive',
    'jv.Common.i18n'
])
.controller('jvSearchFiltersController', [
    '$scope', 'i18n', '$attrs', '$timeout', 'jvSearchUrlRedirectService',
    function($scope, i18n, $attrs, $timeout, jvSearchUrlRedirectService) {
        var summaries = [];
        var loadedFilters = 0;
        $scope.i18n = i18n;
        $scope.resetAll = function() {
            $scope.selectedFilters = {};
            $scope.onReset();
            jvSearchUrlRedirectService.reset();
            $timeout(function() {
                $scope.$broadcast('resetFilter');
            });
        };
        $scope.filterSummaryChanged = function(summary) {
            var index = -1;
            summaries.forEach(function(s, i) {
                if (s.id === summary.id) {
                    index = i;
                }
            });
            if (summary.deleted && index !== -1) {
                // remove old
                summaries.splice(index, 1);
            }
            else if (!summary.deleted && index === -1) {
                // add new
                summaries.push(summary);
            }
            else if (index !== -1) {
                // update existing
                summaries.splice(index, 1, summary);
            }
            if ($attrs.filterSummary) {
                $scope.filterSummary = summaries;
            }
            if ($attrs.isEmpty) {
                $scope.isEmpty = (summaries.length === 0);
            }
        };
        $scope.filterLoaded = function() {
            loadedFilters += 1;
            if (loadedFilters === $scope.availableFilters.length) {
                $scope.$emit('filtersLoaded');
            }
        };
    }
])
.directive('jvSearchFilters', [
    function() {
        return {
            scope: {
                selectedFilters: '=',
                availableFilters: '=',
                filterSummary: '=',
                isEmpty: '=',
                properties: '=',
                onReset: '&'
            },
            controller: 'jvSearchFiltersController',
            templateUrl: window.jvUrls.jhire + '/modules/candidates/directives/filters-template.html'
        };
    }
]);
